import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, image, url, type = "website", noIndex = false }) => {
  const siteName = "THE_ARCHIVE"; 
  const fullTitle = `${title} | ${siteName}`;
  const siteUrl = "https://your-domain.com"; // Future domain yahan update kar dena

  return (
    <Helmet>
      {/* --- Primary Meta Tags --- */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />

      {/* --- Robots Configuration (NoIndex Logic) --- */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* --- Open Graph / Facebook / WhatsApp --- */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={`${siteUrl}${url}`} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || `${siteUrl}/default-og-image.jpg`} />
      <meta property="og:site_name" content={siteName} />

      {/* --- Twitter Card --- */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`${siteUrl}${url}`} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image || `${siteUrl}/default-og-image.jpg`} />

      {/* --- Canonical Link --- */}
      <link rel="canonical" href={`${siteUrl}${url}`} />
    </Helmet>
  );
};

export default SEO;